import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getInventoryMovements } from "../redux/slices/inventorySlice";

const InventoryHistory = () => {
    const dispatch = useDispatch();

    const { movements, loading } = useSelector(
        (state) => state.inventory
    );

    useEffect(() => {
        dispatch(getInventoryMovements());
    }, [dispatch]);

    return (
        <div className="card">
            <div className="card-header">
                <h6 className="mb-0">Inventory History</h6>
            </div>

            <div className="card-body p-4">
                {loading ? (
                    <p className="text-center small">Loading...</p>
                ) : (
                    <div className="table-responsive">
                        <table className="table table-sm table-sm table-bordered mb-0">
                            <thead className="table-dark">
                                <tr>
                                    <th>Date</th>
                                    <th>Product</th>
                                    <th>SKU</th>
                                    <th>Type</th>
                                    <th>Qty</th>
                                    <th>Reason</th>
                                    <th>Reference</th>
                                </tr>
                            </thead>

                            <tbody>
                                {movements?.length > 0 ? (
                                    movements.map((item) => (
                                        <tr key={item._id}>
                                            <td>
                                                {new Date(item.createdAt).toLocaleDateString()}
                                            </td>

                                            <td>{item.productId?.name}</td>

                                            <td>{item.productId?.sku}</td>

                                            <td>
                                                <span
                                                    className={`fw-bold ${item.type === "IN"
                                                            ? "text-success"
                                                            : item.type === "OUT"
                                                                ? "text-danger"
                                                                : "text-warning"
                                                        }`}
                                                >
                                                    {item.type}
                                                </span>
                                            </td>

                                            <td>{item.quantity}</td>

                                            <td>{item.reason}</td>

                                            <td>{item.reference || "-"}</td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan="7" className="text-center text-muted">
                                            No inventory movements found
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>
                )}
            </div>
        </div>
    );
};

export default InventoryHistory;
